import {Reducer} from "redux";
import {fromJS} from "immutable";
import {IApplicationState} from "../types";
import {getEmptyData} from "../../utils/emptyData";

export const dataLayer = {
    id: 'data_highlighted',
    source: 'polygons_highlighted',
    type: 'fill',
    paint: {
        // Fill - #fbdada; Outline - #ba1c1cFill
        "fill-color": "#fb543b",
        "fill-outline-color": "#a90706",
        "fill-opacity": 0.45,
    },
    // filter: ["==", "$type", "Polygon"],
};

const dataLayerLine = {
    id: 'data_highlighted_outline',
    source: 'polygons_highlighted',
    type: 'line',
    paint: {
        // Fill - #fbdada; Outline - #ba1c1cFill
        "line-color": "#fb543b",
        "line-width": 2
    },
    // filter: ["==", "$type", "Polygon"],
};

export const dataLayerLineString = {
    id: 'data_line_highlighted',
    source: 'lines_highlighted',
    type: 'line',
    paint: {
        // Fill - #fbdada; Outline - #ba1c1cFill
        "line-color": "#fb543b",
        "line-width": 6
    },
    // filter: ["==", "$type", "Polygon"],
};

export const dataLayerPoint = {
    id: 'data_point_highlighted',
    source: 'points_highlighted',
    type: 'circle',
    paint: {
        "circle-radius": 10,
        "circle-color": "#fb543b",
        "circle-opacity": 0.45
    },
    // filter: ["==", "$type", "Point"],
};

export const singlePointLayer = {
    id: 'single-point-layer',
    source: 'single-point',
    type: 'symbol',
    "layout": {
        "icon-image": "triangle-15",
        // "icon-color": "#a90706",
        // "text-field": "{title}",
        "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
        "text-offset": [0, 0.6],
        "text-anchor": "top"
    }
};

const reducer: Reducer<IApplicationState['map']> = (state, action) => {
    const {defaultMapStyle, styleName} = action.payload;
    const mapStyle = getMapStyle(state!, state?.mapStyle, defaultMapStyle);
    return {...state, mapStyle, styleName} as IApplicationState['map'];
};

function getMapStyle (state: IApplicationState['map'], oldStyle: any, newStyle: any) {
    let style = fromJS(newStyle);
    // style = style
    //     .setIn(['sources', singlePointLayer.source], fromJS(emptyData))
    //     .setIn(['sources', dataLayer.source], fromJS(emptyData))
    //     .setIn(['sources', dataLayerLineString.source], fromJS(emptyData))
    //     .setIn(['sources', dataLayerPoint.source], fromJS(emptyData));
    const layerKeys = [
        singlePointLayer.source,
        dataLayer.source,
        dataLayerLineString.source,
        dataLayerPoint.source
    ];
    layerKeys.forEach(layerKey => {
        let source = oldStyle.getIn(['sources', layerKey]);
        source = source ? source : fromJS(getEmptyData());
        style = style.setIn(['sources', layerKey], source);
    });

    let layers = style.get('layers');
    if (oldStyle) {
        [...state.layerIds, ...state.measureLayerIds].forEach(layerId => {
            const source =  oldStyle.getIn(['sources', layerId]);
            const layer = oldStyle.get('layers').find((l: any) => l.get('source') === layerId);
            if (source && layer) {
                style = style.setIn(
                    ['sources', layerId], source
                );

                layers = layers.push(
                    layer
                );
            }
        });
    }
    
    layers = layers.push(
        fromJS(dataLayer),
        fromJS(dataLayerLine),
        fromJS(dataLayerLineString),
        fromJS(dataLayerPoint),
        fromJS(singlePointLayer)
    );

    return style.set('layers', layers);
}

export { reducer as loadMapStyle };
